import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from '../../app.component';
// import { DBConnectorService } from '../../service/test.service';
import { PlatformLocation, Location } from '@angular/common'
import { LayoutComponent } from '../../layout/layout.component';

@Component(
    {
        selector: 'timeout',
        templateUrl: './timeout.component.html',
        styleUrls: ['./timeout.component.css']
    }
)
export class TimeoutComponent implements OnInit {

    constructor(private layoutComponent: LayoutComponent, private router: Router, location: PlatformLocation, private locationService: Location) {

        this.layoutComponent.showLoader = false;
        location.onPopState(() => {
            if (window.location.href.includes('/timeout')) {
                history.pushState(null, null, window.location.href);
                // return false;
            }
        });

    }
    loginAgain() {
        this.layoutComponent.showLoader = true;
        this.locationService.replaceState('/login');
        this.layoutComponent.login();
    }
    ngOnInit() {

        // this.dbconnectorService.loggingout(null).subscribe(
        //     (data) => {
        sessionStorage.removeItem('firstName');
        sessionStorage.removeItem('lastName');
        sessionStorage.removeItem('emailId');
        sessionStorage.removeItem('userName');
        sessionStorage.removeItem('IsAdmin');
        sessionStorage.removeItem('IsAuthenticated');
        sessionStorage.removeItem('RoleID');
        sessionStorage.removeItem('loggedinTime');
        sessionStorage.removeItem('IsSessionValid');
        window.sessionStorage.clear();
        if (window.location.href.includes('/timeout')) {
            history.pushState(null, null, window.location.href);
            // return false;
        }
        // });
    }
}
